import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslateBlockDirective } from '@ngx-translate/core';
import { PageSizeService } from '../../../services/page-size.service';
import { ButtonIconComponent } from '../../../shared/components/button-icon/button-icon.component';

@Component({
  selector: 'app-super-console-navigation',
  imports: [
    ButtonIconComponent,
    RouterLinkActive,
    RouterLink,
    TranslateBlockDirective,
  ],
  templateUrl: './super-console-navigation.html',
  styleUrls: [
    './super-console-navigation.css',
    '../../../shared/styles/side-navigation-base.css',
  ],
})
export class SuperConsoleNavigation {
  public openMenu: boolean = false;

  constructor(
    private readonly _pageSizeService: PageSizeService,
  ) {

  }

  public get isMobileView(): boolean {
    return this._pageSizeService.isMobileSize || this._pageSizeService.isTabletSize;
  }

  public toggleMobileView() {
    this.openMenu = !this.openMenu;
  }

  public closeMobileView() {
    this.openMenu = false;
  }
}
